export const endpoints = {
  getChargeBackListById: (id) => `/chargeback/full/${id}`,
  acceptChargeBack: (id ) => `/chargeback/internal/accept/${id}`,
  disputeChargeBack: (id) => `/chargeback/internal/dispute/${id}`,
  getProviderConfig: () => `/providers/config`,
};

